module.exports = __webpack_public_path__ + "media/src/Shared/Assets/roamly/feature_pages-e226304fa47e00ff1d5a600403c9d97731c2ad54622c62fb7d3a573af0f2ed31.svg";